<template>
  <div class="public-booking-view">
    <div class="container">
      <header class="booking-intro">
        <h1>Book an Appointment at Attractive Salon Gondia</h1>
        <p>Choose your service and preferred time — we will confirm your visit shortly.</p>
      </header>
      <div class="booking-form-container">
        <DynamicAppointmentFlow :show-price="false" :initial-phone-number="initialPhone" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import DynamicAppointmentFlow from '@/components/DynamicAppointmentFlow.vue';

export default defineComponent({
  name: 'PublicBookingView',
  components: {
    DynamicAppointmentFlow,
  },
  setup() {
    const route = useRoute();
    const initialPhone = computed(() => {
      const raw = route.query.phone ?? route.query.phoneNumber;
      return typeof raw === 'string' ? raw.trim() : '';
    });

    return { initialPhone };
  },
});
</script>

<style scoped>
.public-booking-view {
  padding: 80px 20px;
  background-color: #f9f9f9;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}

.booking-intro {
  margin-bottom: 28px;
}

.booking-intro h1 {
  margin: 0 0 10px;
  font-size: 1.85rem;
  color: var(--brand-black, #1a1a1a);
  font-weight: 600;
  line-height: 1.25;
}

.booking-intro p {
  margin: 0;
  color: #666;
  font-size: 1rem;
  line-height: 1.5;
}

.booking-form-container {
  background-color: #fff;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  text-align: left;
}

@media (max-width: 768px) {
  .public-booking-view {
    padding: 24px 12px;
    align-items: flex-start;
  }

  .booking-form-container {
    padding: 12px 8px;
  }
}

@media (max-width: 576px) {
  .public-booking-view {
    padding: 16px 8px;
  }

  .booking-form-container {
    padding: 8px 4px;
    border-radius: 8px;
  }
}
</style>
